import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar31Colors = {
  background?: string;
  skin?: string;
  hair?: string;
};

export const Avatar31 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar31Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    skin: colors.skin ?? "#fff",
    hair: colors.hair ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar31">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="Vector"
          d="M243.137 273.14c-3.265-3.479-6.649-6.387-10.057-8.349-15.323-8.793-71.961-27.127-123.363-24.013-21.615 1.31-40.735 13.504-55.653 27.199 26.412 22.257 60.522 35.674 97.769 35.674 34.277 0 65.9-11.359 91.312-30.519l-.008.008Z"
          fill="#000"
        />
        <Path
          id="Vector_2"
          d="M144.66 159.904c.207.119.35.191.453.246-.739-.413-.945-.524-.453-.246Z"
          fill="#FF7222"
        />
        <G id="Group">
          <Path
            id="skin"
            d="M241.866 159.03c2.343-12.209.619-14.561.619-30.281 6.482-44.945-30.018-86.784-58.877-86.791-79.666 0-76.219 25.268-76.219 72.882 0 2.478 3.058 4.321 3.297 6.887-7.555 0-10.168 13.448-6.864 22.988 7.753 22.354 19.947 19.605 20.304 19.415 3.011 6.585.803 44.547-.341 52.244-3.027 20.336-14.068 24.411-14.068 24.411s28.581 12.551 84.233 55.009c6.482-10.295-.731-38.661-8.754-42.283-6.172-1.168 2.836-30.393 3.631-43.436 10.12 2.614 23.918 11.391 32.957-7.951 4.091-8.746 17.198-28.089 20.082-43.102v.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector_3"
            opacity={0.75}
            d="M206.382 162.454c-.564 2.438 2.136 4.059 11.375 3.646 7.61-.342 10.064-4.965 8.571-5.616-1.493-.652-3.495 2.256-8.452 2.256-7.229 0-10.938-2.725-11.502-.286h.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_4"
            d="M156.512 116.484c-.111.08-.048.255.087.239 2.519-.318 15.22-1.589 24.189-1.422 12.018.222 19.636 8.968 22.814 3.829 1.525-2.471.135-7.229-21.798-9.493-9.643-.993-16.745 1.096-25.308 6.847h.016Z"
            fill="#000"
          />
          <Path
            id="Vector_5"
            d="M221.848 119.582c.898 1.335 3.455 3.599 5.497 2.09 3.026-3.154 7.483-5.64 14.552-5.839a292.064 292.064 0 0 0-.23-4.615c-16.801.151-21.042 6.545-19.811 8.364h-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_6"
            d="M198.827 135.453c-2.86-4.885-7.594-9.389-13.544-10.478-2.677-.317-5.393-.008-7.943.977-2.081.795-3.694 2.121-5.235 3.44-2.097 1.446-4.877.898-7.396.604 2.376 1.668 5.903 3.002 8.794 1.573a23.233 23.233 0 0 1 2.018-1.176c-.016.206-.04.421-.04.635 0 3.885 3.257 7.03 7.276 7.03 4.02 0 7.277-3.145 7.277-7.03a7.29 7.29 0 0 0-.072-.937c2.852 1.311 5.719 3.249 8.865 5.37v-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_7"
            d="M243.875 131.91c-1.541-1.319-3.153-2.645-5.234-3.439-2.55-.985-5.259-1.287-7.944-.977-5.95 1.088-10.684 5.592-13.544 10.477 1.621-1.088 3.162-2.137 4.663-3.066.278 3.416 3.225 6.108 6.832 6.108 3.789 0 6.863-2.97 6.863-6.632a6.37 6.37 0 0 0-.993-3.392c2.455.27 5.06 1.223 7.951 3.09 2.892 1.43 6.419.095 8.794-1.573-2.518.294-5.298.842-7.395-.604l.007.008Z"
            fill="#000"
          />
          <Path
            id="hair"
            d="M243.383 139.52c.596-7.204 6.021-12.352 9.905-18.484 8.571-13.115 4.774-24.387-.349-37.685-2.772-22.575-25.475-24.919-25.475-24.919s-4.258-11.542-24.371-24.355c-20.113-12.812-52.293-11.494-56.725-5.973-58.433-1.43-73.16 63.517-73.16 78.061 0 8.095.588 15.252 1.636 21.591-2.828-2.216-6.53-3.813-9.77-1.009-6.308 5.449-2.296 13.48-2.296 13.48s-6.887-4.591-14.918 4.02c-8.031 8.603-5.45 14.918-5.45 14.918s-18.929 16.92-7.744 36.429c11.184 19.501 23.806 20.367 23.806 20.367s-1.144 12.337 12.337 13.481c13.48 1.143 15.49-6.602 15.49-6.602s.286 7.459 9.182 4.306c8.889-3.154 32.124-23.807 25.817-38.153 4.313 0 4.075 1.652 4.353.167 1.43-7.507-.897-24.665-.897-24.665-29.471-11.471-24.602-40.457-13.449-40.457s16.149 9.429 16.149 9.429l7.936-1.58c.254 4.059 1.319 8.046 3.638 11.82 2.058 3.598 5.823 6.895 7.793 9.929 2.637 3.924 2.716 9.04 1.628 13.544-1.239 5.251-4.861 9.5-6.601 14.886-1.89 5.735-.731 12.233 2.423 17.214 1.446 2.446 2.931 4.599 3.304 7.014.366 2.343-.127 5.163-1.382 7.205-1.072 1.851-3.487 2.319-4.567 4.242-1.518 3.423.079 7.324 1.676 10.318 1.366 2.439 3.058 4.671 4.98 6.697-3.272-4.155-6.505-9.342-5.989-14.664.159-1.279.691-2.192 1.875-2.828 5.854-2.629 7.212-10.311 4.726-15.585-.58-1.343-1.255-2.574-1.843-3.781-2.391-4.568-2.955-9.787-1.04-14.474 2.097-4.925 6.219-9.301 7.895-14.743 1.43-4.432 1.962-9.167.858-13.758-.913-4.345-4.4-8.659-6.696-11.812-4.528-6.228-4.298-12.209-2.788-18.477.429-.723.921-1.414 1.461-2.041 3.472-.58 6.895-1.47 10.24-2.574 8.626-3.05 17.571-7.562 23.552-14.807 7.046-8.992 10.16-20.749 9.85-32.18 3.154-2.454 6.832-4.59 10.557-5.719-4.178-14.727-22.901-23.33-22.901-23.33s7.173 2.296 13.147 6.307c5.973 4.02 10.557 12.813 14.338 18.358 9.357 0 21.709 10.136 21.908 17.976.199 7.84 9.556 12.813 13.345 18.358 3.122 4.575.826 17.984-.079 22.544-1.502 2.843-2.717 5.838-3.154 9.182-2.073 18.723 15.315 17.015 14.172 34.96-.286 4.321-1.597 8.436-3.567 12.384-2.534 5.425-6.697 10.676-6.697 16.952.128 6.196 3.662 11.851 8.389 15.815-4.314-4.138-7.419-9.89-7.118-15.792.461-5.973 4.83-10.676 7.69-15.863 4.782-7.943 7.26-18.81 2.335-27.445-3.757-6.49-10.35-10.247-9.357-18.191l-.008-.008Z"
            fill={c.hair}
          />
          <Path
            id="Vector_8"
            opacity={0.75}
            d="M220.831 174.853c-3.146 0-4.154 1.533-4.154 1.533s-4.004-1.874-7.34-1.874c-3.337 0-6.387 1.708-9.525 2.129-3.177.429-8.666-.104-8.666-.104s7.165 16.245 24.8 15.435c10.215-.469 12.082-11.804 12.344-12.432 0 0-4.321-4.695-7.467-4.695l.008.008Zm-4.226 10.454c-12.074 0-20.558-5.084-24.561-7.936 4.035 1.994 12.241 3.432 24.156 3.432 5.878 0 8.762-.079 11.907-1.16-3.121 1.454-5.64 5.664-11.502 5.664Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_9"
            opacity={0.75}
            d="M186.356 228.576c.747-6.871 2.637-18.977 2.224-19.072-22.139-4.949-35.285-16.046-40.552-20.932 0 .453 11.28 34.523 38.328 39.996v.008Z"
            fill="#2E2017"
          />
        </G>
      </G>
    </Svg>
  );
};
